<template>
  <div class="layout-header" :style="'background:'+(scrollBgStatus ? scrollBg: defaultBg)">
    <div class="content main-container">
      <div class="logo">
        <router-link to="/">
        <img src="@/assets/slices/icon_logo.png" class="logo" alt="logo"/>
        </router-link>
      </div>
      <div class="menu">
        <div class="parent-menu" @mouseenter="onMouseEnter(-1)" @mouseleave="onMouseLeave">
          <div class="name" :class="-1 === currentIndex ? 'active' : ''">
            <router-link to="/">首页</router-link>
            <div class="border"></div>
          </div>
        </div>
        <template v-for="(item, index) in navigationList">
          <div class="parent-menu" @mouseenter="onMouseEnter(index)" @mouseleave="onMouseLeave">
            <div class="name" :class="index === currentIndex ? 'active' : ''">
              <a :href="item.navigationPath" v-if="item.navigationPath">
                {{ item.navigationName }}
              </a>
              <span v-else>{{ item.navigationName }}</span>
              <div class="border"></div>
            </div>
            <div class="son-list" v-show="hoverIndex === index"
                 :style="'background:'+(scrollBgStatus ? scrollBg: defaultBg)">
              <template v-for="(menu, key) in item.secNavigationVoList">
                <a :href="menu.secNavigationPath">
                  <div class="son-menu"  @mouseenter="onSonMouseEnter(key)">
                    {{ menu.secNavigationName }}
                  </div>
                </a>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="lang">
      <a href="https://en.e3d-meta.com" target="_blank">EN</a></div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState(['navigationList']),

  },
  props: {
    defaultBg: {
      type: String,
      default: 'rgba(0,0,0,0.3)'
    },
    scrollBg: {
      type: String,
      default: 'rgba(0,0,0,0.3)'
    }
  },
  data() {
    return {
      hoverIndex: -1,
      currentIndex: -1,
      hoverSonIndex: -1,
      scrollBgStatus: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop, true);

    this.routerIndex()
  },
  methods: {
    routerIndex() {
      let pathList = {
        '/source/software/detail' : '/source/software',
        '/news/detail' : '/news/center'
      }
      let path = this.$route.fullPath
      if(pathList[this.$route.path] !== undefined ) {
        path = pathList[this.$route.path]
      }

      this.navigationList.forEach((item, index) => {
        if (item.secNavigationVoList.length === 0 && item.navigationPath === path) {
          this.currentIndex = index
        } else {
          item.secNavigationVoList.forEach(menu => {
            if (menu.secNavigationPath === path) {
              this.currentIndex = index
            }
          })
        }
      })
    },
    // 监听回到顶部按钮距浏览器顶部的距离，滚动的距离如果大于浏览器高度时，设置 btnFlag 为true,否则就是false
    scrollToTop() {
      let that = this;
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop)
      //为了计算距离顶部的高度，当高度大于50显示回顶部图标，小于50则隐藏
      that.scrollBgStatus = scrollTop > 80;
    },
    onMouseEnter(index) {
      this.hoverIndex = index
    },
    onMouseLeave() {
      this.hoverIndex = -1
      this.hoverSonIndex = -1
    },
    onSonMouseEnter(index) {
      this.hoverSonIndex = index
    },

  },
  watch: {
    navigationList:{
      handler(newName,oldName){
        this.routerIndex()
      },
      deep:true //为true，表示深度监听，这时候就能监测到a值变化
    }
  }
}
</script>


<style lang="scss" scoped>
.layout-header {
  height: 80px;
  box-shadow: 20px 7px 13px 1px rgba(0, 0, 0, 0.1000);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo{
      width: 136px;
      height: 41px;
    }

    .menu {
      display: flex;
      font-size: 18px;
      color: #fff;

      .parent-menu {
        position: relative;

        .name {
          text-align: left;
          margin-right: 50px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          min-width: 100px;
          cursor: pointer;
          position: relative;
          &:hover{
            color: #EB6100;
          }

          &.active {
            color: #EB6100;
            .border{
              position: absolute;
              bottom: 10px;
              left: 0;
              width: 37px;
              height: 2px;
              background: #EB6100;
            }
          }
        }

        .son-list {
          background: #3C3A3A;
          position: absolute;
          top: 80px;
          left: 0;
          padding: 10px 0;

          .son-menu {
            padding: 0 20px;
            height: 34px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &:hover {
              background: #EB6100;
            }
          }
        }
      }

    }
  }


  .lang {
    width: 50px;
    height: 34px;
    opacity: 1;
    background: url('../../assets/slices/icon_dotted_line.png') no-repeat center center;
    background-size: cover;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    position: absolute;
    right: 50px;
  }

}
</style>
